import { render, staticRenderFns } from "./CandidateSearchResults.vue?vue&type=template&id=e445b77a&"
import script from "./CandidateSearchResults.vue?vue&type=script&lang=js&"
export * from "./CandidateSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports